import SignalTable from 'components/global/SignalTable/SignalTable';
import SimpleCard from 'components/global/SimpleCard';
import FounderInvestorRow from 'components/views/FounderInvestors/_components/FounderInvestorRow';
import { fetchAndSetInvestorData } from 'components/views/FounderInvestors/_helpers/founderInvestors.resolvers';
import { $filter, $list, $view } from 'signals/global.signals';
import { useEffectAsync } from 'utils/useEffectAsync';
import UniversalInput from 'components/global/UniversalInput';
import { handleFilterChange, handleShowModal } from 'components/global/_helpers/global.helpers';
import { Button, Col, Row } from 'react-bootstrap';
import { INVESTOR_TYPE_OPTIONS } from 'components/global/_helpers/global.consts';
import FounderCreateInvestorModal from 'components/views/FounderInvestors/_components/FounderCreateInvestorModal';
import PageTitle from 'components/global/PageTitle/PageTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import FounderAddToDealModal from 'components/views/FounderInvestors/_components/FounderAddToDealModal';
import withDismount from 'hocs/withDismount';
import FounderInvestorEditModal from 'components/views/FounderInvestors/_components/FounderInvestorEditModal';
import FounderInvestorDeleteModal from 'components/views/FounderInvestors/_components/FounderInvestorDeleteModal';

const FounderInvestors = () => {
  useEffectAsync(fetchAndSetInvestorData);
  return (
    <>
      <PageTitle
        Buttons={(
          <Button
            className="text-white border-dark bg-dark"
            variant="transparent"
            size="sm"
            onClick={() => handleShowModal('founder-investor-create', {})}
          >
            <FontAwesomeIcon icon={faPlus} className="me-8" size="sm" />
            Add Investor
          </Button>
        )}
      >
        Investors
      </PageTitle>
      <SimpleCard>
        <Row className="mb-16 pb-0 align-items-center border-bottom border-gray-700">
          <Col md={6}>
            <UniversalInput
              placeholder="Search Investors by name..."
              className="rounded border-0 bg-gray-700 w-100"
              name="search"
              value={$filter.value.investorSearch}
              onChange={(e) => handleFilterChange({ name: 'investorSearch', value: e.target.value })}
            />
          </Col>
          <Col md={3}>
            <UniversalInput
              type="select"
              options={INVESTOR_TYPE_OPTIONS}
              name="investorTypes"
              placeholder="Filter By Investor Type"
              isMulti
              value={INVESTOR_TYPE_OPTIONS.filter((status) => $filter.value.investorTypes?.includes(status.value))}
              onChange={(selectedOptions) => {
                const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                handleFilterChange({ name: 'investorTypes', value: selectedValues });
              }}
            />
          </Col>
          <Col md={3}>
            <UniversalInput
              type="select"
              options={$view.value.dealOptions}
              name="dealIds"
              placeholder="Filter By Deal(s)"
              isMulti
              value={$view.value.dealOptions?.filter((deal) => $filter.value.dealIds?.includes(deal.value))}
              onChange={(selectedOptions) => {
                const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                handleFilterChange({ name: 'dealIds', value: selectedValues });
              }}
            />
          </Col>
        </Row>
        <SignalTable
          headers={[{
            key: 'name',
            value: 'Name',
          }, {
            key: 'email',
            value: 'Email',
          }, {
            key: 'investorType',
            value: 'Investor Type',
          }, {
            key: 'potentialCommitment',
            value: 'Potential Commitment',
          }, {
            key: 'deals',
            value: 'Deals',
          }, {
            key: 'Actions',
            value: 'Actions',
          }]}
          rows={FounderInvestorRow({
            data: $list.value?.data?.filter((investor) => {
              const search = $filter.value.investorSearch?.trim();
              const types = $filter.value.investorTypes;
              const deals = $filter.value.dealIds;

              const isInSearchOrSearchIsEmpty = !search || investor.investorName?.toLowerCase().includes(search.toLowerCase());
              const isInTypesOrTypesIsEmpty = !types || types.length === 0 || types.includes(investor.investorType);
              const isInDealsOrDealsIsEmpty = !deals || deals.length === 0
                ? true
                : investor.deals?.some((deal) => deals.includes(deal.id));

              return isInSearchOrSearchIsEmpty && isInTypesOrTypesIsEmpty && isInDealsOrDealsIsEmpty;
            }) || [],
          })}
        />
        <FounderCreateInvestorModal />
        <FounderAddToDealModal />
        <FounderInvestorEditModal />
        <FounderInvestorDeleteModal />
      </SimpleCard>
    </>
  );
};

export default withDismount(FounderInvestors);
